var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',_vm._g({attrs:{"name":_vm.name}},_vm.transition),[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }